
export default function anotherFeature() {
    console.log("Hello, World part 2!");
}

//sayHello();